/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * The user's team's current match (live or awaiting their action)
 * @export
 * @interface MyTournamentNextMatchResponse
 */
export interface MyTournamentNextMatchResponse {
    /**
     * Bracket match id for the user's active match
     * @type {string}
     * @memberof MyTournamentNextMatchResponse
     */
    matchId: string;
    /**
     * Display name of the opposing team
     * @type {string}
     * @memberof MyTournamentNextMatchResponse
     */
    opponentName?: string;
    /**
     * Scheduled start time (ms epoch), when set
     * @type {number}
     * @memberof MyTournamentNextMatchResponse
     */
    scheduledTime?: number;
}

/**
 * Check if a given object implements the MyTournamentNextMatchResponse interface.
 */
export function instanceOfMyTournamentNextMatchResponse(value: object): value is MyTournamentNextMatchResponse {
    if (!('matchId' in value) || value['matchId'] === undefined) return false;
    return true;
}

export function MyTournamentNextMatchResponseFromJSON(json: any): MyTournamentNextMatchResponse {
    return MyTournamentNextMatchResponseFromJSONTyped(json, false);
}

export function MyTournamentNextMatchResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): MyTournamentNextMatchResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'matchId': json['matchId'],
        'opponentName': json['opponentName'] == null ? undefined : json['opponentName'],
        'scheduledTime': json['scheduledTime'] == null ? undefined : json['scheduledTime'],
    };
}

export function MyTournamentNextMatchResponseToJSON(json: any): MyTournamentNextMatchResponse {
    return MyTournamentNextMatchResponseToJSONTyped(json, false);
}

export function MyTournamentNextMatchResponseToJSONTyped(value?: MyTournamentNextMatchResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'matchId': value['matchId'],
        'opponentName': value['opponentName'],
        'scheduledTime': value['scheduledTime'],
    };
}

